import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Redirect, Navigate, useNavigate } from 'react-router-dom';
import './App.css'
import { store, setStore } from './app/store';

import Login from './pages/Authentication/Login/Login';
import MainDashboard from './pages/Main/MainDashboard/MainDashboard';
import Event from './pages/Client/Event/Event';
import Gallery from './pages/Client/Gallery/Gallery';
import Members from './pages/Client/Members/Members';
import ManageMembers from './pages/Client/Members/ManageMembers';
import Notice from './pages/Client/Notice/Notice';
import Contacts from './pages/Client/Contacts/Contacts';
import BulkEmail from './pages/Client/Bulk-Email/BulkEmail';
import Home from './pages/Client/Home/Home';
import Logout from './pages/Authentication/Logout/Logout';
import NoticeCategory from './pages/Client/Notice/NoticeCategoryManagement';
import PendingSubscriptions from './pages/Client/Members/PendingSubscriptions';
import LifetimeSubscriptions from './pages/Client/Members/LifetimeSubscriptions';
import SocialMediaPosting from './pages/Client/SocialMediaPosting/SocialMediaPosting';
import RulesProcedures from './pages/Client/RulesProcedures/RulesProcedures';
import ExecutiveCommittee from './pages/Client/ExecutiveCommittee/ExecutiveCommittee';
import AlumniSpeak from './pages/Client/AlumniSpeak/AlumniSpeak';
import Announcement from './pages/Client/Announcement/Announcement';
import TransactionReport from './pages/Client/TransactionReport/TransactionReport';
function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const accessToken = localStorage.getItem('access_token');
    setIsAuthenticated(!!accessToken);
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={isAuthenticated ? <MainDashboard /> : <Login />} />
        <Route path="/dashboard" element={isAuthenticated ? <MainDashboard /> : <Login />} />
        <Route path="/manage-members" element={isAuthenticated ? <ManageMembers /> : <Login />} />
        <Route path="/event" element={isAuthenticated ? <Event /> : <Login />} />
        <Route path="/gallery" element={isAuthenticated ? <Gallery /> : <Login />} />
        <Route path="/notice" element={isAuthenticated ? <Notice /> : <Login />} />
        <Route path="/notice-category" element={isAuthenticated ? <NoticeCategory /> : <Login />} />
        <Route path="/pending-subscriptions" element={isAuthenticated ? <PendingSubscriptions /> : <Login />} />
        <Route path="/lifetime-subscriptions" element={isAuthenticated ? <LifetimeSubscriptions /> : <Login />} />
        <Route path="/social-media-posting" element={isAuthenticated ? <SocialMediaPosting /> : <Login />} />
        <Route path="/rules-procedures" element={isAuthenticated ? <RulesProcedures /> : <Login />} />
        <Route path="/executive-committee" element={isAuthenticated ? <ExecutiveCommittee /> : <Login />} />
        <Route path="/alumni-speak" element={isAuthenticated ? <AlumniSpeak /> : <Login />} />
        <Route path="/members" element={isAuthenticated ? <Members /> : <Login />} />
        <Route path="/contacts" element={isAuthenticated ? <Contacts /> : <Login />} />
        <Route path="/homepage" element={isAuthenticated ? <Home /> : <Login />} />
        <Route path="/logout" element={isAuthenticated ? <Logout /> : <Login />} />
        <Route path="/bulk-email" element={isAuthenticated ? <BulkEmail /> : <Login />} />
        <Route path="/announcement" element={isAuthenticated ? <Announcement /> : <Login />} />
        <Route path="/transaction-report" element={isAuthenticated ? <TransactionReport /> : <Login />} />
      </Routes>
    </Router>
  );
}

export default App;